<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">渠道信息</p>
      <div class="content-input">
<!--        <div class="content-input-item">-->
<!--          <label>是否开启广告：</label>-->
<!--          <el-select v-model="isOpenAd" placeholder="Select" style="width: 7em">-->
<!--            <el-option v-for="item in isOpenAdArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
        <div class="content-input-item">
          <label>渠道：</label>
          <el-input type="search" placeholder="请输入渠道"  v-model="searchValue" style="width: 16em;">
            <template #prefix>
              <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
            </template>
          </el-input>
        </div>

        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
<!--          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
        </div>
      </div>
    </div>
    <div class="content-main">
<!--      <div class="content-button">-->
<!--        <div>-->
<!--          <el-button type="primary" @click="editChannelDialog(-1)">新建话题</el-button>-->
<!--        </div>-->
<!--        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>-->
<!--      </div>-->
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" ></el-table-column>
          <el-table-column property="packageName" label="包名" v-if="checkColList.indexOf('包名') > -1"></el-table-column>
          <el-table-column property="channel" label="渠道" v-if="checkColList.indexOf('渠道') > -1"></el-table-column>
          <el-table-column property="" label="注册时是否必须上传头像" v-if="checkColList.indexOf('注册时是否必须上传头像') > -1">
            <template #default="scope">
              {{scope.row.isUploadHead == 1 ? '是' : '否'}}
            </template>
          </el-table-column>
          <el-table-column property="" label="是否有审核版" v-if="checkColList.indexOf('是否有审核版') > -1">
            <template #default="scope">
              {{scope.row.isHadCheck == 1 ? '是' : '否'}}
            </template>
          </el-table-column>
          <el-table-column property="" label="是否开启广告" v-if="checkColList.indexOf('是否开启广告') > -1">
            <template #default="scope">
              {{scope.row.isOpenAd == 1 ? '是' : '否'}}
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editChannelDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getChannelPageList } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import ChannelDialog from "./components/channelDialog";

export default {
  name: "ChannelIndex",
  components: {  },
  data() {
    return {


      // isOpenAdArray: [
      //   { label: '不限', value: -1 },
      //   { label: '否', value: 0 },
      //   { label: '是', value: 1 }
      // ],
      // isOpenAd: -1,

      //刷新组
      colList: ['创建时间', '包名', '渠道', '注册时是否必须上传头像', '是否有审核版', '是否开启广告', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

      searchValue: '',
      //时间
      startTime: '',
      endTime: '',
      isChecked: true,
    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.state = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['searchValue'] = this.searchValue;
      // param['isOpenAd'] = this.isOpenAd;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getChannelPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editChannelDialog(idx, row) {
      let _title = '';
      let channelForm = {}
      if (idx > -1) {
        _title = '渠道信息'
        channelForm = Object.assign({}, row);
      }else {
        _title = '渠道信息'
      }
      Dialog.open({
        title: _title,
        component: ChannelDialog,
        data: {
          channelForm: channelForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
          if(idx > -1) {
            row.isUploadHead = result.isUploadHead
            row.isHadCheck = result.isHadCheck
            row.isOpenAd = result.isOpenAd
          } else {
            this.getPage()
          }
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
